/* tslint:disable */
/* eslint-disable */
/**
 * Tanagra Service API
 * github.com/DataBiosphere/tanagra
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CriteriaGroupSection } from './CriteriaGroupSection';
import {
    CriteriaGroupSectionFromJSON,
    CriteriaGroupSectionFromJSONTyped,
    CriteriaGroupSectionToJSON,
} from './CriteriaGroupSection';

/**
 * 
 * @export
 * @interface CohortUpdateInfo
 */
export interface CohortUpdateInfo {
    /**
     * Human readable name of the cohort
     * @type {string}
     * @memberof CohortUpdateInfo
     */
    displayName?: string;
    /**
     * Description of the cohort
     * @type {string}
     * @memberof CohortUpdateInfo
     */
    description?: string;
    /**
     * Criteria group sections that define the entity filter
     * @type {Array<CriteriaGroupSection>}
     * @memberof CohortUpdateInfo
     */
    criteriaGroupSections?: Array<CriteriaGroupSection>;
}

/**
 * Check if a given object implements the CohortUpdateInfo interface.
 */
export function instanceOfCohortUpdateInfo(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CohortUpdateInfoFromJSON(json: any): CohortUpdateInfo {
    return CohortUpdateInfoFromJSONTyped(json, false);
}

export function CohortUpdateInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CohortUpdateInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'displayName': !exists(json, 'displayName') ? undefined : json['displayName'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'criteriaGroupSections': !exists(json, 'criteriaGroupSections') ? undefined : ((json['criteriaGroupSections'] as Array<any>).map(CriteriaGroupSectionFromJSON)),
    };
}

export function CohortUpdateInfoToJSON(value?: CohortUpdateInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'displayName': value.displayName,
        'description': value.description,
        'criteriaGroupSections': value.criteriaGroupSections === undefined ? undefined : ((value.criteriaGroupSections as Array<any>).map(CriteriaGroupSectionToJSON)),
    };
}

